// assets/scroll-animations.js

/** @type {typeof import('gsap')} */
// @ts-ignore
const gsap = window.gsap;

/** @type {typeof import('gsap/ScrollTrigger')} */
// @ts-ignore
const ScrollTrigger = window.ScrollTrigger;

(function() {
  'use strict';

/* ===========================================
 * iOS最適化のみ
 * =========================================== */
(function() {
  function initScrollOptimization() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    if (isIOS) {
      ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
      });
      
      ScrollTrigger.defaults({
        pinType: "fixed",
        invalidateOnRefresh: false
      });
    }
  }
  
  window.initScrollOptimization = initScrollOptimization;
})();


/* ===========================================
 * ページ初期化（トップへスクロール + フェードイン）
 * =========================================== */
function initPageSetup() {
  if (window.location.pathname !== '/' && window.location.pathname !== '/ja') {
    function revealPage() {
      document.body.classList.add('loaded');
      document.body.style.transition = 'opacity 0.3s ease';
      document.body.style.opacity = '1';
    }

    if (window.__fontsReady) {
      revealPage();
    } else {
      var interval = setInterval(function() {
        if (window.__fontsReady) {
          clearInterval(interval);
          revealPage();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
        revealPage();
      }, 3000);
    }
    return;
  }
}

/* ===========================================
 * Opening Animation - トップページのみ
 * =========================================== */
function initOpeningAnimation() {
  const kvLogo = document.querySelector('[data-kv-logo]');
  const hasPlayed = sessionStorage.getItem('openingAnimationPlayed');
  
  // トップページ以外、またはハッシュがある場合
  if (window.location.pathname !== '/' && window.location.pathname !== '/ja' || window.location.hash || hasPlayed) {
    document.body.classList.add('loaded');
    document.body.style.opacity = '1';

    // KVロゴを非表示
    if (kvLogo) {
      kvLogo.style.display = 'none';
    }

    return;
  }

  sessionStorage.setItem('openingAnimationPlayed', 'true');

  const kvText = document.querySelector('[data-kv-text]');
  const headerLogos = document.querySelectorAll('[data-header-logo]'); 
  const kvSlider = document.querySelector('[data-kv-slider]');
  
  // kvLogoがない場合でもページは表示
  if (!kvLogo) {
    document.body.classList.add('loaded');
    gsap.to(document.body, {
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    });
    return;
  }
  
  const isMobile = window.innerWidth <= 750;

  // 初期状態を設定
  gsap.set(kvLogo, { opacity: 0 });
  if (kvText) gsap.set(kvText, { opacity: 0, y: 20 });
  if (!isMobile && headerLogos.length > 0) {
    headerLogos.forEach(logo => {
      logo.classList.remove('opacity-0');
    });
  }

  if (window.lenis) {
    window.lenis.stop();
  }
  
  // クリックを無効化
  document.body.style.pointerEvents = 'none';
  
  // bodyを固定（スクロール無効）
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  
  // ページフェードイン（即座に）
  gsap.to(document.body, {
    opacity: 1,
    duration: 1,
    ease: "power2.out",
    onComplete: () => {
      document.body.classList.add('loaded');
    }
  });

  // スクロール解除関数
  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';

    // クリックを有効化
    document.body.style.pointerEvents = '';
    
    // Lenisを初期化または再開
    if (window.initLenis) {
      window.initLenis();
    } else if (window.lenis) {
      window.lenis.start();
    }
  }
  
  // オープニングタイムライン
  const openingTl = gsap.timeline({
    delay: 0.8,
    onComplete: () => {
      // スライダーを開始
      if (window.startKVSlider) {
        window.startKVSlider();
      }
    }
  });
  
  openingTl
    // 1. ロゴフェードイン
    .to(kvLogo, { 
      opacity: 1, 
      duration: 1.5,
      ease: "power2.out"
    })
    
    // 2. 0.5秒待機
    .to({}, { duration: 0.5 })
    
    // 3. ロゴフェードアウト
    .to(kvLogo, { 
      opacity: 0, 
      duration: 1.5, 
      ease: "power2.inOut"
    });
  
  // 4. テキストフェードイン
  if (kvText) {
    openingTl.to(kvText, { 
      opacity: 1,
      y: 0,
      duration: 1.6,
      ease: "power2.out",
      onStart: () => {
        unlockScroll();
      }
    }, "-=0.4");
  } else {
    openingTl.call(() => {
      unlockScroll();
    });
  }
  
  // 5. モバイルの場合、ヘッダーロゴもフェードイン
  if (isMobile && headerLogos.length > 0) {
    const headerLogoPosition = "-=1.6";
  
    openingTl.call(() => {
      headerLogos.forEach(logo => {
        logo.classList.remove('opacity-0');
      });
    }, null, headerLogoPosition);
    
    openingTl.to(headerLogos, {
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    }, headerLogoPosition);
  }
  
  // 6. ロゴを非表示
  openingTl.set(kvLogo, { display: 'none' });
}

/* ===========================================
 * KV Slider - シンプル版
 * =========================================== */
  function initKVSlider() {
    const kvSlider = document.querySelector('[data-kv-slider]');
    const slides = document.querySelectorAll('[data-kv-slide]');
    const kvText = document.querySelector('[data-kv-text]');
    
    if (!kvSlider || slides.length === 0) return;
    
    let currentIndex = 0;
    const slideCount = slides.length;
    const intervalTime = 4000; // 4秒ごとに切り替え
    
    // 初期状態：最初のスライドのみ表示
    slides.forEach((slide, i) => {
      slide.style.opacity = i === 0 ? '1' : '0';
      slide.style.zIndex = i === 0 ? '10' : '1';
    });
    
    // スライド切り替え関数
    function changeSlide() {
      const currentSlide = slides[currentIndex];
      const nextIndex = (currentIndex + 1) % slideCount;
      const nextSlide = slides[nextIndex];
      
      // 次のスライドを前面に
      nextSlide.style.zIndex = '11';
      
      // フェードイン/アウト
      gsap.to(nextSlide, { opacity: 1, duration: 1.5, ease: "power2.inOut" });
      gsap.to(currentSlide, { 
        opacity: 0, 
        duration: 1.5, 
        ease: "power2.inOut",
        onComplete: () => {
          currentSlide.style.zIndex = '1';
          nextSlide.style.zIndex = '10';
        }
      });
      
      currentIndex = nextIndex;
    }
    
    window.startKVSlider = function() {
      setTimeout(() => {
        changeSlide();
        slideInterval = setInterval(changeSlide, intervalTime);
      }, 2500);
    };

    // KVテキストのスクロールアニメーション
    if (kvText) {
      const textContainer = kvText.closest('.w-screen');
      const containerHeight = textContainer ? textContainer.offsetHeight : window.innerHeight;
      
      gsap.to(kvText, {
        scrollTrigger: {
          trigger: kvSlider,
          start: "top top",
          end: () => `+=${containerHeight * 0.5}`,
          scrub: 3,
          invalidateOnRefresh: true,
          markers: false,
          id: "kv-text"
        }
      });
    }
  }

  /* ===========================================
   * MAF Animation
   * =========================================== */
  function initMAFAnimation() {
    const kvSlider = document.querySelector('[data-kv-slider]');
    const mafBackground = document.querySelector('[data-maf-bg]');
    const mafText = document.querySelector('[data-maf-text]');
    const mafSection = mafText ? mafText.closest('section') : null;
    
    if (!mafBackground || !mafText || !kvSlider) return;

    gsap.set(mafText, { 
      zIndex: 20, 
    });

    // mafTextアニメーション
    gsap.to(mafText, {
      opacity: 1,
      scrollTrigger: {
        trigger: mafText,
        start: "50% 50%",
        endTrigger: mafSection,  
        end: "bottom top",
        scrub: 3,
        pinSpacing: false,
        markers: false,
        pin: true,
        id: "maf-text-in"
      }
    });

    // KVフェードアウト + MAFフェードイン
    let fadeTl = gsap.timeline({
      scrollTrigger: {
        trigger: mafText,
        start: `0% 50%`,
        end: '50% 50%', 
        scrub: 2,
        markers: false,
        id: "maf-fade-in"
      }
    });

    fadeTl
      .to(kvSlider, { opacity: 0 })  
      .to(mafBackground, { opacity: 1 }, "<");

    ScrollTrigger.create({
      trigger: mafSection,
      start: "top bottom",  // セクションが画面下端に入った瞬間
      end: "bottom top",    // セクションが画面上端を抜けた時
      onEnter: () => {
        // 下にスクロールしてセクションに入った時
        mafBackground.classList.remove('hidden');
      },
      onEnterBack: () => {
        // 上にスクロールして戻った時（即座に表示）
        mafBackground.classList.remove('hidden');
      },
      onLeave: () => {
        // 下にスクロールしてセクションを抜けた時
        mafBackground.classList.add('hidden');
      },
      onLeaveBack: () => {
        // 上にスクロールしてセクションを抜けた時
        mafBackground.classList.add('hidden');
      },
      markers: false,
      id: "maf-bg-toggle"
    });
  }

  /* ===========================================
   * STORY Animation
   * =========================================== */
  function initStoryAnimation() {
    const storyTexts = document.querySelectorAll('[data-story-text]');

    if (storyTexts.length > 0) {
      storyTexts.forEach((text, index) => {
        // 初期状態を設定
        gsap.set(text, { 
          y: 100, 
          opacity: 0 
        });

        // 個別にフェードイン
        gsap.to(text, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: text,
            start: 'top 80%',
            end: 'top 50%',
            scrub: 3,
            markers: false,
            id: `story-text-${index}`
          }
        });
      });
    }
  }

  /* ===========================================
   * Parallax Animation (遅延スクロール)
   * =========================================== */
  function initParallaxAnimation() {
    const items = document.querySelectorAll("[data-parallax-front]"); 
    
    for (const item of items) {
      const y = item.getAttribute("data-y") ?? "15%";
      const delay = parseFloat(item.getAttribute("data-delay")) || 0.4; 
      const target = item.children;

      gsap.fromTo(
        target,
        { y: y },
        {
          y: `-${y}`,
          scrollTrigger: {
            trigger: item, 
            start: "top bottom",
            end: "bottom top", 
            scrub: delay, 
          },
          ease: "none",
        }
      );
    }
  }

/* ===========================================
 * ABOUT Animation
 * =========================================== */
function initAboutAnimation() {
  const aboutSections = document.querySelectorAll('[data-about-section]');
  const allAboutBgs = document.querySelectorAll('[data-about-bg]');
  const productSection = document.querySelector('[data-product-section]') || 
                         document.querySelector('#product');
  const processSection = document.querySelector('[data-process-section]') || 
                         document.querySelector('#process');

  if (aboutSections.length === 0) return;

  const firstAboutSection = aboutSections[0];
  const lastAboutSection = aboutSections[aboutSections.length - 1];
  const firstBg = firstAboutSection.querySelector('[data-about-bg]');
  const lastBg = lastAboutSection.querySelector('[data-about-bg]');

  const isMobile = window.innerWidth <= 750;
  const absoluteLeft = isMobile ? 0 : -80; 

  if (firstBg) {
    gsap.set(firstBg, { 
      position: 'absolute',
      top: 0,
      left: `${absoluteLeft}px`, 
      width: '100vw',
      height: '100vh',
      zIndex: 0,
      opacity: 1
    });

    ScrollTrigger.create({
      trigger: firstAboutSection,
      start: "top bottom",
      onEnter: () => {
        gsap.set(firstBg, { 
          position: 'fixed',
          left: 0
        });
      },
      onLeaveBack: () => {
        gsap.set(firstBg, { 
          position: 'absolute',
          left: `${absoluteLeft}px`, 
        });
      },
      markers: false,
      id: `about-first-position-change`
    });
  }

  allAboutBgs.forEach((bg, index) => {
    if (index === 0) return; 
    
    gsap.set(bg, { 
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 0,
      opacity: 0
    });
  });

  aboutSections.forEach((section, sectionIndex) => {
    const aboutText = section.querySelector('[data-about-text]');
    const aboutBg = section.querySelector('[data-about-bg]');
    const imageWrappers = section.querySelectorAll('[data-about-image]');
    const flexContainer = section.querySelector('[data-about-container]');
    
    if (!aboutText || imageWrappers.length === 0 || !flexContainer) {
      return;
    }

    // 次のセクションへのクロスフェード
    const nextSection = aboutSections[sectionIndex + 1];
    const nextBg = nextSection ? nextSection.querySelector('[data-about-bg]') : null;

    if (aboutBg && nextBg) {
      // クロスフェードタイムライン
      gsap.timeline({
        scrollTrigger: {
          trigger: nextSection,
          start: "top bottom",
          end: "top top",
          scrub: 1,
          markers: false,
          id: `about-crossfade-${sectionIndex}`
        }
      })
      .to(aboutBg, { opacity: 0 }, 0)
      .to(nextBg, { opacity: 1 }, 0);
    }
  
    // テキストをpin
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      endTrigger: flexContainer,  
      end: "bottom bottom",
      pin: aboutText,
      pinSpacing: false,
      anticipatePin: 0,
      invalidateOnRefresh: false,
      markers: false,
      id: `about-text-${sectionIndex}`
    });
  });

  // 最後のABOUT背景：PROCESSセクションが top top に到達したらfixed解除
  if (lastBg && productSection) {
    ScrollTrigger.create({
      trigger: productSection,
      start: "top top",
      onEnter: () => {
        // fixedを解除してabsolute
        gsap.set(lastBg, { 
          position: 'absolute',
          opacity: 0 
        });
      },
      onLeaveBack: () => {
        // fixedに戻す
        gsap.set(lastBg, { 
          position: 'fixed',
          opacity: 1
        });
      },
      markers: false,
      id: `about-last-unlock`
    });
  }
}

  /* ===========================================
   * PROCESS Animation
   * =========================================== */
  function initProcessAnimation() {
    const processIcons = document.querySelectorAll('[data-process-icon]');
    const processArrows = document.querySelectorAll('[data-process-arrow]');
    const shipping = document.querySelector('[data-process-shipping]');
    
    if (processIcons.length === 0) return;
    
    // 初期状態を設定
    gsap.set(processIcons, { opacity: 0, y: 20 });
    gsap.set(processArrows, { opacity: 0, scale: 0 });
    if (shipping) gsap.set(shipping, { opacity: 0, scale: 0 });
    
    // タイムラインを作成
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: processIcons[0],
        start: "top 60%",
        end: "bottom 20%",
        toggleActions: "play none none none",
        markers: false
      }
    });
    
    // アイコン1: フェードイン
    tl.to(processIcons[0], {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    })
    // 矢印1: 右から現れる
    .to(processArrows[0], {
      opacity: 1,
      scale: 1,
      x: -10,
      duration: 0.4,
      ease: "back.out(1.7)"
    }, "-=0.2")
    
    // アイコン2: フェードイン
    .to(processIcons[1], {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    }, "-=0.1")
    // 矢印2: 下から現れる
    .to(processArrows[1], {
      opacity: 1,
      scale: 1,
      y: -10,
      duration: 0.4,
      ease: "back.out(1.7)"
    }, "-=0.2")
    
    // アイコン3: フェードイン
    .to(processIcons[2], {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    }, "-=0.1")
    // 矢印3: 左から現れる
    .to(processArrows[2], {
      opacity: 1,
      scale: 1,
      x: 10,
      duration: 0.4,
      ease: "back.out(1.7)"
    }, "-=0.2")
    
    // アイコン4: フェードイン
    .to(processIcons[3], {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    }, "-=0.1")
    // 矢印4: 左から現れる
    .to(processArrows[3], {
      opacity: 1,
      scale: 1,
      x: 10,
      duration: 0.4,
      ease: "back.out(1.7)"
    }, "-=0.2")
    
    // 出荷: スケールとフェード
    .to(shipping, {
      opacity: 1,
      scale: 1,
      duration: 0.5,
      ease: "back.out(1.7)"
    }, "-=0.1");
  }

  /* ===========================================
   * PRODUCT Animation
   * =========================================== */
  function initProductAnimation() {
    const productImages = document.querySelectorAll('[data-product-image]');

    if (productImages.length > 0) {
      productImages.forEach((image, index) => {
        // 初期状態を設定
        gsap.set(image, { 
          y: 20, 
          opacity: 0 
        });

        // 個別にフェードイン
        gsap.to(image, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          scrollTrigger: {
            trigger: image,
            start: 'top 80%',
            end: 'top 50%',
            toggleActions: "play none none none",
            markers: false,
            id: `product-image-${index}`
          }
        });
      });
    }
  }

/* ===========================================
 * WHO WE ARE Animation - 背景固定版
 * =========================================== */
function initWhoWeAreAnimation() {
  const whoWeAreSection = document.querySelector('[data-whoweare-section]');
  const whoWeAreBg = document.querySelector('[data-whoweare-bg]');
  
  if (!whoWeAreSection || !whoWeAreBg) return;

  // 次のセクションを取得
  const nextSection = whoWeAreSection.nextElementSibling;

  // 背景をfixedに設定（初期非表示）
  gsap.set(whoWeAreBg, { 
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 0,
    opacity: 0,
    visibility: 'hidden'
  });

  // 100vh前（top bottom）でfixedに切り替え、即座に表示
  ScrollTrigger.create({
    trigger: whoWeAreSection,
    start: "top bottom",  // 100vh前
    onEnter: () => {
      gsap.set(whoWeAreBg, { 
        visibility: 'visible',
        opacity: 1
      });
    },
    onLeaveBack: () => {
      gsap.set(whoWeAreBg, { 
        visibility: 'hidden',
        opacity: 0
      });
    },
    markers: false,
    id: 'whoweare-bg-show'
  });

  // 次のセクションが top top に到達したら背景を非表示
  if (nextSection) {
    ScrollTrigger.create({
      trigger: nextSection,
      start: "top top",
      onEnter: () => {
        gsap.set(whoWeAreBg, { 
          visibility: 'hidden',
          opacity: 0
        });
      },
      onLeaveBack: () => {
        gsap.set(whoWeAreBg, { 
          visibility: 'visible',
          opacity: 1
        });
      },
      markers: false,
      id: 'whoweare-bg-hide'
    });
  }
}

  /* ===========================================
 * メイン初期化関数
 * =========================================== */
function initScrollAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    setTimeout(initScrollAnimations, 100);
    return;
  }
 
  gsap.registerPlugin(ScrollTrigger);

  // ページ初期化
  initPageSetup();
  
  // iOS最適化
  initScrollOptimization();

  const hasPlayed = sessionStorage.getItem('openingAnimationPlayed');

  // オープニングアニメーション
  initOpeningAnimation();
  
  // すべてのアニメーションを初期化
  initKVSlider();

  if (hasPlayed && window.startKVSlider) {
    window.startKVSlider();
  }
  initMAFAnimation();
  initStoryAnimation();
  initParallaxAnimation();
  initAboutAnimation();
  initProcessAnimation();
  initProductAnimation();
  initWhoWeAreAnimation();

  // 1回だけリフレッシュ
  ScrollTrigger.refresh();
}

// 段階的に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}

// 画像読み込み完了後に1回だけリフレッシュ
window.addEventListener('load', () => {
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);
});

// // フォント読み込み完了後に1回だけリフレッシュ
// if (document.fonts) {
//   document.fonts.ready.then(() => {
//     ScrollTrigger.refresh();
//   });
// }

})();